import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Form/FatReport/index'
import { v2_yards } from '../../../actions/v2/masterData';
import { v2_ships } from '../../../actions/v2/projectAndVessel';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_fetchFatReportFormFields, v3_submitFatReportForm } from '../../../actions/v3/siteManagement';
import Swal from 'sweetalert2';

const FatReport = (props) => {
  const location = useLocation();
  const { data } = location.state || {};
  const [commonDetails, setCommonDetails] = useState({
    ship: { value: '', options: [], error: '' },
    date: { value: '', error: '' },
    finalSubmit: { value: false },
    yard: { value: '', options: [] },
  });

  const [state, setState] = useState({
    witnessManufacturer: { name: 'witnessManufacturer', value: '', error: '', isRequired: false },
    witnessShipyard: { name: 'witnessShipyard', value: '', error: '', isRequired: false },
    witnessCompany: { name: 'witnessCompany', value: '', error: '', isRequired: false },
    witnessOwner: { name: 'witnessOwner', value: '', error: '', isRequired: false },
    reportedBy: { name: 'reportedBy', value: '', error: '', isRequired: false },
    placeOfInspection: { name: 'placeOfInspection', value: '', error: '', isRequired: false },
    dateOfInspection: { name: 'dateOfInspection', value: '', error: '', isRequired: false },
    result: { name: 'result', value: '', error: '', isRequired: false },
    itemOfInspectionResultAndProblem: { name: 'itemOfInspectionResultAndProblem', value: '', error: '', isRequired: false },
    comment: { name: 'comment', value: '', error: '', isRequired: false },
    feedback: { name: 'feedback', value: '', error: '', isRequired: false },

  });

  const [photoState, setPhotoState] = useState([{ file: "", new: true }]);
  const [documentState, setDocumentState] = useState([{ file: "", new: true }]);

  // ✅ Generic handler for both photo & document states
  const handleFileChange = (e, index, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (type === "photo") {
      setPhotoState((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, file, new: true } : item
        )
      );
    } else if (type === "document") {
      setDocumentState((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, file, new: true } : item
        )
      );
    }
  };

  // ✅ Add new row
  const handleAdd = (type) => {
    const newRow = { file: "", new: true };
    if (type === "photo") {
      setPhotoState((prev) => [...prev, newRow]);
    } else if (type === "document") {
      setDocumentState((prev) => [...prev, newRow]);
    }
  };

  // ✅ Remove row
  const handleRemove = (index, type) => {
    if (type === "photo") {
      setPhotoState((prev) => {
        const updated = prev.filter((_, i) => i !== index);
        return updated.length ? updated : [{ file: "", new: true }];
      });
    } else if (type === "document") {
      setDocumentState((prev) => {
        const updated = prev.filter((_, i) => i !== index);
        return updated.length ? updated : [{ file: "", new: true }];
      });
    }
  };


  const [showLoader, setShowLoader] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;

    setState(prevState => ({
      ...prevState,
      [name]: {
        ...prevState[name],
        value,
        error: '', // Optionally clear error on change
      },
    }));
  };


  // Load yards
  useEffect(() => {
    v2_yards().then((res) => {
      if (res.status) {
        setCommonDetails((prev) => ({
          ...prev,
          yard: { ...prev.yard, options: res.result },
        }));
      }
    });
  }, []);

  // Load ships when yard changes
  useEffect(() => {
    if (commonDetails.yard.value) {
      v2_ships(null, null, commonDetails.yard.value).then((res) => {
        if (res.status) {
          setCommonDetails((prev) => ({
            ...prev,
            ship: { ...prev.ship, options: res.result },
          }));
        }
      });
    } else {
      setCommonDetails((prev) => ({
        ...prev,
        ship: { value: '', options: [] },
      }));
    }
  }, [commonDetails.yard.value]);

  useEffect(() => {
    const params = data ? JSON.parse(atob(data)) : null;

    if (params) {
      setShowLoader(true);

      v3_fetchFatReportFormFields(params.FORM_ID)
        .then((res) => {
          if (res.status) {
            const { records, photos, documents, commonDetails } = res.result;

            if (params.FORM_ID) {
              // ✅ Common Details
              setCommonDetails((prev) => ({
                ...prev,
                yard: { ...prev.yard, value: commonDetails?.YARD_ID || '' },
                ship: { ...prev.ship, value: commonDetails?.SHIP_ID || '' },
                date: { ...prev.date, value: commonDetails?.DATE || '' },
                finalSubmit: { ...prev.finalSubmit, value: Boolean(commonDetails?.FINAL_SUBMITTED) },
              }));

              // ✅ Records
              setState((prev) => ({
                ...prev,
                witnessManufacturer: { ...prev.witnessManufacturer, value: records?.WITNESS_MANUFACTURER || '' },
                witnessShipyard: { ...prev.witnessShipyard, value: records?.WITNESS_SHIPYARD || '' },
                witnessCompany: { ...prev.witnessCompany, value: records?.WITNESS_COMPANY || '' },
                witnessOwner: { ...prev.witnessOwner, value: records?.WITNESS_OWNER || '' },
                reportedBy: { ...prev.reportedBy, value: records?.REPORTED_BY || '' },
                dateOfInspection: { ...prev.dateOfInspection, value: records?.DATE_OF_INSPECTION || '' },
                placeOfInspection: { ...prev.placeOfInspection, value: records?.PLACE_OF_INSPECTION || '' },
                result: { ...prev.result, value: records?.RESULT || '' },
                itemOfInspectionResultAndProblem: {
                  ...prev.itemOfInspectionResultAndProblem,
                  value: records?.ITEM_OF_INSPECTION_RESULT_AND_PROBLEM || ''
                },
                comment: { ...prev.comment, value: records?.COMMENT || '' },
                feedback: { ...prev.feedback, value: records?.FEEDBACK || '' },
              }));

              // ✅ Photos (already uploaded → new: false)
              setPhotoState(
                (photos || []).map((p) => ({
                  id: p.ID,
                  file: p.ORIGINAL_NAME,
                  new: false,   // important!
                }))
              );

              // ✅ Documents (already uploaded → new: false)
              setDocumentState(
                (documents || []).map((d) => ({
                  id: d.ID,
                  file: d.ORIGINAL_NAME,
                  new: false,   // important!
                }))
              );
            }
          } else {
            toast.error(res.error || "Error fetching FAT Report data");
          }
        })
        .catch(() => {
          toast.error("Something went wrong while fetching.");
        })
        .finally(() => {
          setShowLoader(false);
        });
    }
  }, []);


  const onSubmit = async () => {

    // 1. Validation
    const errors = [];
    if (!commonDetails.yard.value) errors.push('Select a yard.');
    if (!commonDetails.ship.value) errors.push('Select a ship.');
    if (!commonDetails.date.value) errors.push('Select a date.');

    // Validate each row
    if (commonDetails.finalSubmit.value) {
      Object.entries(state).forEach(([key, field]) => {

        const isRequired = field.isRequired; // Enforce all fields if finalSubmit is true
        if (isRequired && !field.value) {
          errors.push(`${key.replace(/_/g, ' ')} is required.`);
        }
      });
    }



    if (errors.length > 0) {
      toast.error(errors.join('\n'));
      return;
    }
    // If final submit is true, confirm before proceeding
    if (commonDetails.finalSubmit.value) {
      const confirmResult = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to submit the reports for Office Review?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it',
        cancelButtonText: 'Cancel',
      });
      if (!confirmResult.isConfirmed) return;
    }


    const formattedRow = {};
    Object.keys(state).forEach((key) => {
      formattedRow[key] = state[key].value;
    });


    // 3. Build full payload
    const createPayload = () => {
      const formData = new FormData();

      // ✅ Common details as one object (JSON string)
      formData.append(
        "commonDetails",
        JSON.stringify({
          yardId: commonDetails.yard.value,
          shipId: commonDetails.ship.value,
          date: commonDetails.date.value,
          finalSubmit: commonDetails.finalSubmit.value,
        })
      );

      // ✅ Checklist items (as JSON string)
      formData.append("checklistItems", JSON.stringify(formattedRow));

      // ✅ Photos as array

      // Arrays for existing records
      const existingPhotos = [];
      const existingDocuments = [];

      // ✅ Photos
      photoState.forEach((item) => {
        if (item.file && item.new) {
          // new uploads
          formData.append("photos", item.file);
        } else if (!item.new && item.id) {
          existingPhotos.push(item.id);
        }
      });

      // ✅ Documents
      documentState.forEach((item) => {
        if (item.file && item.new) {
          formData.append("documents", item.file);
        } else if (!item.new && item.id) {
          existingDocuments.push(item.id);
        }
      });

      // ✅ Add existing arrays as JSON
      formData.append("existingPhotos", JSON.stringify(existingPhotos));
      formData.append("existingDocuments", JSON.stringify(existingDocuments));

      return formData;
    };



    // 4. Submit
    setShowLoader(true);
    v3_submitFatReportForm(createPayload())
      .then((res) => {
        setShowLoader(false);
        if (res.status) {
          toast.success(res.result.message || 'Submitted successfully!');
          props.history.push(constant.Authedcomponent.submittedFatReport.url);
        } else {
          toast.error(res.error || 'Submission failed.');
        }
      })
      .catch((err) => {
        setShowLoader(false);
        toast.error('Submission failed.');
        console.error('Submit Error:', err);
      });
  };
  return (
    <Layout
      title={'FAT Report'}
    >
      <div className="row">
        <div className="col-lg-12">
          <div className="card" id={1}>
            <div className="card-body">
              <div className="checklist-title-bx">
                <div className="row">
                  <div className="col-md-12">
                    <div className="text-center">
                      <h4>Factory Acceptance Test Report</h4>
                      <p>
                        Following to be checked and confirmed before official delivery
                        of the vessel
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 ">
                  <div className="report-index-top">
                    <table>
                      <tbody>
                        <tr>
                          <td className="hd-s2 w150">
                            <p>Yard</p>
                          </td>
                          <td className="td-input-bx">
                            <div className="hull-select-box">
                              <select
                                className="form-select"
                                value={commonDetails.yard.value}
                                disabled={data ? true : false}
                                onChange={(e) =>
                                  setCommonDetails((prev) => ({
                                    ...prev,
                                    yard: { ...prev.yard, value: e.target.value },
                                  }))
                                }
                              >

                                <option value={''}>Select Yard</option>
                                {commonDetails.yard.options.map((item) => {
                                  return (<option value={item.ID}> {item.YARD_NAME}</option>)
                                })}
                              </select>
                            </div>
                          </td>
                          <td className="hd-s2 pl10 w150">
                            <p>Hull No</p>
                          </td>
                          <td className="td-input-bx">
                            <div className="hull-select-box">
                              <select
                                className="form-select"
                                disabled={data ? true : false}
                                value={commonDetails.ship.value}
                                onChange={(e) => {
                                  setCommonDetails((prev) => ({
                                    ...prev,
                                    ship: { ...prev.ship, value: e.target.value }
                                  }));
                                }}


                              >

                                <option value={''}>Select Hull</option>
                                {commonDetails.ship.options.map((item) => {
                                  return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                })}
                              </select>
                            </div>
                          </td>
                          <td className="hd-s2 w150">
                            <p>Date</p>
                          </td>
                          <td className="td-input-bx">
                            <td className="">
                              <input
                                type="date"
                                className="form-control"
                                value={commonDetails.date.value}
                                onChange={(e) =>
                                  setCommonDetails((prev) => ({
                                    ...prev,
                                    date: { ...prev.date, value: e.target.value },
                                  }))
                                }
                              />
                            </td>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
              <Form
                onChange={handleChange}
                state={state}
                onSubmit={onSubmit}
                isFinalSubmitting={commonDetails.finalSubmit.value}
                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                  ...prev,
                  finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                }))}

                photoState={photoState}
                documentState={documentState}
                handleAdd={handleAdd}
                handleRemove={handleRemove}
                handleFileChange={handleFileChange}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default FatReport